import type { WelcomeMessageData, UserMessageData, UserConfirmMessageData, ConfirmMessageData, ThinkMessageData, VersionCreatedMessageData, PlanMessageData, PatentRecallKeywordGenerationMessageData, PatentRecallEvaluationMessageData, ModuleContentMessageData, AgentConfirmMessageData, InterruptedMessageData } from './triz-events';

// 对应前端messagelist中的单个模块的类型，对应block内组件。

export enum COMPONENT_TYPE {
    WELCOME = 'welcome',
    USER = 'user',
    AGENT = 'agent',
    VERSION = 'version_created',
    PLAN = 'plan',
    FILE_UPLOAD = 'file_upload',
    BATCH_PATENT_RECALL = 'batch_patent_recall',
    TRIZ_MATRIX_ANALYSIS = 'triz_matrix_analysis',
    NODE = 'node',
    INTERRUPTED = 'interrupted'
}

export interface WelcomeComponent {
    type: COMPONENT_TYPE.WELCOME,
    content: WelcomeMessageData,
}

export interface UserComponent {
    type: COMPONENT_TYPE.USER,
    content: UserMessageData | UserConfirmMessageData,
}

/**
 * 模块列表项类型（包含模块数据和完成状态）
 */
export interface ModuleListItem {
    module_key: string;
    [key: string]: any; // 允许包含 message.data 的其他字段
}

/**
 * 合并后的Bot消息数据（基于message_group合并）
 */
export interface MergedBotMessageData {
    message_group: string;
    business_id: string;

    // 消息内容
    title?: string;
    agent_message?: string;
    confirm_data?: ConfirmMessageData;
    agent_confirm_data?: AgentConfirmMessageData;
    think_message?: ThinkMessageData;
    step?: number | undefined;
    module_list?: ModuleListItem[];
    isCompleted?: boolean;
}

export interface AgentComponent {
    type: COMPONENT_TYPE.AGENT,
    content: MergedBotMessageData,
}

export interface VersionCreatedComponent {
    type: COMPONENT_TYPE.VERSION,
    content: VersionCreatedMessageData,
}

export interface PlanComponent {
    type: COMPONENT_TYPE.PLAN,
    content: PlanMessageData,
}

export interface PatentRecallComponent {
    type: COMPONENT_TYPE.BATCH_PATENT_RECALL,
    content: PatentRecallKeywordGenerationMessageData | PatentRecallEvaluationMessageData,
}

export interface ModuleContentMessageComponent {
    type: COMPONENT_TYPE.NODE,
    content: ModuleContentMessageData,
}

export interface InterruptedComponent {
    type: COMPONENT_TYPE.INTERRUPTED,
    content: InterruptedMessageData,
}

export type MessageComponent = WelcomeComponent | UserComponent | AgentComponent | VersionCreatedComponent | PlanComponent | PatentRecallComponent | ModuleContentMessageComponent | InterruptedComponent
